import { onUnmounted } from "vue";
import { useRouter } from "vue-router";

export function useIntervalManager() {
  const router = useRouter();
  const intervals = new Set();
  let isClearing = false;

  const addInterval = (intervalId) => {
    intervals.add(intervalId);
  };

  const removeInterval = (intervalId) => {
    if (intervals.has(intervalId)) {
      clearInterval(intervalId);
      intervals.delete(intervalId);
    }
  };

  const clearAllIntervals = () => {
    if (isClearing) return; // Предотвращаем множественные вызовы

    isClearing = true;
    intervals.forEach((intervalId) => {
      clearInterval(intervalId);
    });
    intervals.clear();
    isClearing = false;
  };

  // Очищаем все интервалы при размонтировании компонента
  onUnmounted(() => {
    clearAllIntervals();
  });

  // Очищаем все интервалы при навигации (только один раз)
  if (!window.__intervalManagerInitialized) {
    router.beforeEach(() => {
      clearAllIntervals();
    });
    window.__intervalManagerInitialized = true;
  }

  return {
    addInterval,
    removeInterval,
    clearAllIntervals,
  };
}
